import { FormattedMessage } from 'react-intl';
import { Text, TextType } from 'ui-components/components/text';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import HelpArticleLink from '../../../../../help-article-link';
import { messages } from './messages';
import { linkIDs } from '../../../../../../services/link-service/links';

export const CustomsInfo = () => {
  return (
    <BannerMessageV2
      content={
        <Text
          textType={TextType.Caption}
          value={
            <FormattedMessage
              {...messages.customsUpdatedInfoBanner}
              values={{
                helpLink: (chunks) => <HelpArticleLink articleId={linkIDs.CustomsUpdates}>{chunks}</HelpArticleLink>,
              }}
            />
          }
        />
      }
      status={BannerStatus.Info}
    />
  );
};
